
import React, { useState } from 'react';
import './Navbar.css';

import {
  Link,
  useNavigate
} from 'react-router-dom';

function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  const goToContact = () => {

    setMenuOpen(false);

    navigate('/');

    setTimeout(() => {

      const contactSection =
        document.getElementById('contact');

      if (contactSection) {

        contactSection.scrollIntoView({
          behavior: 'smooth'
        });

      }

    }, 300);

  };

  return (

    <nav className="navbar">

      <div className="navbar-container">

        {/* LOGO */}

        <div className="logo-section">

          <Link
            to="/"
            onClick={() => setMenuOpen(false)}
          >

            <img
              src="/logo.png"
              alt="Reasonable Services"
              className="navbar-logo"
            />

          </Link>

        </div>

        {/* MOBILE MENU ICON */}

        <div
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? '✕' : '☰'}
        </div>

        {/* MENU */}

        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>

          <li>
         <Link
  to="/"
  onClick={() => {
    setMenuOpen(false);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }}
>
  Home
</Link>
          </li>

          <li>
            <Link
              to="/services"
              onClick={() => setMenuOpen(false)}
            >
              Services
            </Link>
          </li>

          <li>
            <Link
              to="/ourstory"
              onClick={() => setMenuOpen(false)}
            >
              About
            </Link>
          </li>

          <li>

            <button
              className="contact-nav-btn"
              onClick={goToContact}
            >
              Contact
            </button>

          </li>

        </ul>

        {/* WHATSAPP BUTTON */}

        <a
          href="https://wa.me/27767201554"
          target="_blank"
          rel="noopener noreferrer"
          className="nav-btn"
        >
          WhatsApp Us
        </a>

      </div>

    </nav>

  );

}

export default Navbar;
